import * as selectors from './selectors';
import * as constants from './constants';
import * as actionCreators from './action-creators';
import {reducer} from './reducer';

export const responsesTable = {
    selectors,
    constants,
    actionCreators,
    reducer,
};
